<template>
  <div>
    <b-row align-v="center">
      <CheckBoxConfiguration
        :controller="FeatureCheckCntller"
        :switchprop="true"
      />
    </b-row>
    <b-row
      v-if="FeatureCheckCntller.value"
      class="text-center title-subsection mr-1 mt-2"
    >
      <p>Feature Check</p>
    </b-row>
    <b-row v-if="FeatureCheckCntller.value">
      <FeatureCheck :sectionconfig="sectionconfig" />
    </b-row>
  </div>
</template>

<script>
import CheckBoxConfiguration from '@/components/properties/elements/CheckBoxConfiguration'
import FeatureCheck from '@/components/properties/specificFeatures/FeatureCheck'
import {checkBoxGraphConfCtrller, baseConfCtrller} from '@/assets/classes/configuration.js'
import { ConfigName } from '@/common/sharedDefinitions/commonPlotDefinitions'
import { mapGetters, mapActions } from 'vuex'

const zoneNotify='FeatureCheckWrapper'
const rootContextFolder = 'ReportViewer/FeatureCheck'

export default {
  name: zoneNotify,
  components:{
    CheckBoxConfiguration,
    FeatureCheck
  },
  props: {
    sectionconfig:{
      type:String,
      required: true
    },
  },
  data(){
    return {
            elementsConfig:[],
      FeatureCheckCntller: new checkBoxGraphConfCtrller(ConfigName.FeatureCheckActivate,'Feature Check',false,rootContextFolder+'FeatureCheck',true)
    }
  },
  computed: mapGetters([
    'getCurrentReportViewer',
  ]),
    // Watch and mounted() section added
    //============================
    watch:{
    sectionconfig(){
      this.configureStudy()
    }
  },
  mounted(){
    this.elementsConfig = [
      this.FeatureCheckCntller,
    ]
    this.configureStudy()
    this.$watch(
      'FeatureCheckCntller.value',
      () => {
        this.verifyConfiguration()
      }
    );
  },
    //=================
  methods:{
    ...mapActions([
      'addInitReqConfWindow',
      'removeFromInitReqConfWindow'
    ]),
    configureStudy(){
      try{
        this.elementsConfig.forEach(conf=>conf.configCategory=this.sectionconfig)
        this.FeatureCheckCntller.formatKeyValue(this.sectionconfig)
        this.FeatureCheckCntller.setParent(this)
        this.verifyConfiguration()

      }catch(err){
        const errTitle='Error loading Feature Check'
        const errText=`Error loading Feature Check for ${this.sectionconfig}. Message: ${err}`
        this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR,errTitle,errText,zoneNotify)
      }
    },
    verifyConfiguration(){
      if(this.FeatureCheckCntller.value){
        this.elementsConfig.forEach(conf=>conf.setParent(this))
        const definedAoI = baseConfCtrller.getConfiguration(this.getCurrentReportViewer.configuration[this.sectionconfig], `${ConfigName.BaseFeatureCheck}.aoiTimes`)
        if(typeof(definedAoI) === 'undefined' || definedAoI.length === 0)
          this.addInitReqConfWindow({type:'AREA_INTEREST_VALUES', study: this.sectionconfig})
      }else if(
        typeof(this.getCurrentReportViewer.configuration[this.sectionconfig]) !== 'undefined'
        &&typeof(this.getCurrentReportViewer.configuration[this.sectionconfig][ConfigName.BaseFeatureCheck])!=='undefined'
      ){
        delete this.getCurrentReportViewer.configuration[this.sectionconfig][ConfigName.BaseFeatureCheck]
        this.removeFromInitReqConfWindow({type:'CHRONO_VALUES', study: this.sectionconfig})
      }
    },
  }
}
</script>